import { reportAppFailure } from './errorReporter.js';

/**
 * Captura los errores que hoy se pierden en la consola del navegador: de
 * componentes Vue, promesas sin catch y scripts. Se reportan sin detalles
 * (solo qué tipo fue) y se siguen escribiendo en la consola. Las fallas HTTP
 * ya pasan por el cliente axios y no se reportan aquí otra vez.
 */
export function installGlobalErrorHandlers(app, { win = window, report = reportAppFailure, log = console.error } = {}) {
    const safeReport = (operation) => {
        try { report(operation); } catch { /* Reportar es opcional. */ }
    };

    app.config.errorHandler = (error, instance, info) => {
        log('[erpz] error de componente', error, info);
        safeReport('ui.componente');
    };

    win.addEventListener('unhandledrejection', (event) => {
        if (event?.reason?.isAxiosError) return;
        safeReport('ui.promesa');
    });

    // Sin objeto de error son avisos del navegador ("Script error.", ResizeObserver): ruido.
    win.addEventListener('error', (event) => {
        if (!event?.error) return;
        safeReport('ui.script');
    });
}
